import { ArrowRight, Heart } from "lucide-react";
import React, { ReactNode } from "react";
import { Panel, Placeholder } from "rsuite";
import { Button as RsButton, LiquidPill } from "components/ui/v2";

interface SideCardProps {
  title: string | ReactNode;
  children: ReactNode;
  loading?: boolean;
  onViewMore?: () => void;
  buttonText?: string;
  defaultExpanded?: boolean;
  variant?: "default" | "v2";
  collapsible?: boolean;
  icon?: ReactNode;
  hideViewMore?: boolean;
  headerTag?: ReactNode;
}

const SideCard: React.FC<SideCardProps> = ({
  children,
  title,
  loading = false,
  onViewMore,
  buttonText,
  defaultExpanded = false,
  collapsible = true,
  variant = "default",
  icon = <Heart size={16} strokeWidth={1} color="#0073FF" />,
  hideViewMore = false,
  headerTag,
}) => {
  return (
    <Panel
      header={
        variant === "default" ? (
          <span className="p-0 pl-1 font-medium hover:underline">{title}</span>
        ) : (
          <div className="flex items-center gap-1">
            <div className="grid content-center justify-center rounded-full text-center">
              {icon}
            </div>
            <span className="p-0 pl-1 font-medium hover:underline">
              {title}
            </span>
            {headerTag ? <span className="ml-1">{headerTag}</span> : null}
          </div>
        )
      }
      className={`flex w-full flex-col rounded-xl border border-gray-200 ${variant === "default" ? "bg-gray-50" : "bg-white"} shadow-sm dark:border-gray-900 dark:bg-gray-900`}
      collapsible={collapsible}
      defaultExpanded={defaultExpanded}
    >
      <div
        className={`${variant === "default" ? "grid" : "flex items-center justify-between"} relative`}
      >
        {loading ? (
          <Placeholder className="h-24 w-full" />
        ) : (
          <div>{children}</div>
        )}

        {buttonText && variant === "default" && (
          <div className="flex justify-center">
            <RsButton
              variant="secondary"
              size="lg"
              className="rs-btn-big bg-gray-200 dark:bg-gray-800"
              onClick={onViewMore}
            >
              {buttonText}
            </RsButton>
          </div>
        )}

        {buttonText && variant === "v2" && !hideViewMore && (
          <div className="absolute bottom-1 right-0">
            <LiquidPill
              as="button"
              type="button"
              shape="circle"
              size="sm"
              variant="slate"
              appearance="tinted"
              shadow="neutral"
              icon={<ArrowRight className="h-4 w-4" />}
              aria-label={buttonText}
              onClick={onViewMore}
            />
          </div>
        )}
      </div>
    </Panel>
  );
};

export default SideCard;
